module.exports = __webpack_public_path__ + "img/logo copy.edc7d222.png";